export const handleNoteClick = (noteId, navigate) => {
  if (!noteId) {
    console.error('ID de note invalide');
    return;
  }
  navigate(`/get-expenses/${noteId}`);
};



export const handleCancel = (noteId, navigate) => {
  navigate(`/get-expenses/${noteId}`);
};

export const validateExpenseType = (expenseType, expensePresets) => {
  return Object.keys(expensePresets).includes(expenseType);
}; 